import AktenSidebar from 'application/components/pages/internal/akten/sidebar'
import React from 'react'

const ProviderPopupSidebarComponent = (props) => {
    return <AktenSidebar {...props} />
}

export default ProviderPopupSidebarComponent
